<template>
  <span class="pi-cname">
    <router-link v-if="link" :to="link" class="pi-link pi-cname__link">{{ displayName }}</router-link>
    <span v-else class="pi-cname__text">{{ displayName }}</span>
    <span v-if="showShard && shard" class="pi-cname__shard" :class="{ 'is-stacked': stacked }"><span class="pi-sr">banco </span>{{ shard }}</span>
    <span v-if="demo" class="pi-badge pi-badge--muted pi-cname__demo" :title="demoTitle || null">Demonstração</span>
  </span>
</template>

<script>
import { companyLink, routeOrigin } from "./piNavigation.js";

export default {
  name: "pi-company-name",
  props: {
    companyId: { type: [String, Number], default: "" },
    shardCode: { type: String, default: "" },
    name: { type: String, default: "" },
    query: { type: Object, default: null },
    origin: { type: String, default: "" },
    showShard: { type: Boolean, default: true },
    stacked: { type: Boolean, default: false },
    demo: { type: Boolean, default: false },
    demoTitle: { type: String, default: "" },
  },
  computed: {
    id() {
      return this.companyId === null || this.companyId === undefined ? "" : String(this.companyId).trim();
    },
    shard() {
      return (this.shardCode || "").trim();
    },
    currentQuery() {
      if (this.query) return this.query;
      return this.$route && this.$route.query ? this.$route.query : {};
    },
    linkOrigin() {
      if (this.origin) return this.origin;
      return this.$route ? routeOrigin(this.$route.path) : "";
    },
    link() {
      return companyLink(this.id, this.shard, this.currentQuery, this.linkOrigin);
    },
    displayName() {
      return (this.name || "").trim() || this.id || "Empresa";
    },
  },
};
</script>

<style src="./pi.css"></style>

<style scoped>
.pi-cname {
  display: inline;
}

.pi-cname__link:focus {
  outline: 2px solid #1b59f8;
  outline-offset: 2px;
}

.pi-cname__shard {
  margin-left: 6px;
  font-size: 11px;
  font-weight: 400;
  color: #6b7280;
  white-space: nowrap;
}

.pi-cname__shard.is-stacked {
  display: block;
  margin: 2px 0 0;
}

.pi-cname__demo {
  margin-left: 6px;
  vertical-align: baseline;
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/components/pi/piCompanyName.vue